// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const companytype_list = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","companytypes", data)
    commit('listCompanyTypes', res.data);
    commit('dealerLoading', false);
}

export const company_get = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","companies", data)
    commit('listCompany', res.data);
    commit('dealerLoading', false);
}

export const company_id_list = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","companies", data)
    commit('listCompany', res.data);
    commit('dealerLoading', false);
}

export const companyDetail = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","companies/"+data)
    commit('companyDetail', res.data);
    commit('dealerLoading', false);
}

export const company_add = async ({ commit }, data) => {
   commit('dealerLoading', true);
   let res;
   res = await sendReq("post","companies", data)
   commit('companyInfo', res);
   commit('companyStatus', res.data);
   commit('dealerLoading', false);
}

export const company_delete = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("delete","companies/"+data.id, data)
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const dealer_edit = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("put","companies/"+data.id, data)
    commit('companyInfo', res);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
 }

export const companyaddresses_get = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","companies/"+data.parent_id+"/addresses", data)
    commit('companyAddresses', res.data);
    commit('dealerLoading', false);
}

export const companyaddresses_add = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("post","companies/"+data.parent_id+"/addresses", data)
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const reserveaccount_reserve = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("post","companies/"+data.id+"/reserve-account", data)
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}


export const companyaddresses_edit = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("put","companies/"+data.parent_id+"/addresses/"+data.id, data)
    commit('companyAddressStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const companyaddresses_delete = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("delete","companies/"+data.parent_id+"/addresses/"+data.id, data)
    commit('companyAddressStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const companyuser_get = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","companies/"+data.parent_id+"/users", data)
    commit('companyUsers', res.data);
    commit('dealerLoading', false);
}

export const companyuser_add = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("post","companies/"+data.parent_id+"/users", data)
    commit('companyUserStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const companyuser_edit = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("put","companies/"+data.parent_id+"/users/"+data.id, data)
    commit('companyUserStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const companyuser_delete = async ({ commit }, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("delete","companies/"+data.parent_id+"/users/"+data.id, data)
    commit('companyUserStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const company_state = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("put","companies/"+data.id+"/active", data)
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const serviceForm_add = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("post","technical-service", data)
    commit('serviceFormStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const appointment_get = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","technical-service", data)
    commit('serviceForms', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const appointment_appointment = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("put","technical-service/"+data.id, data)
    commit('serviceFormStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const serviceFormMovementList = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","technical-service/"+data.id+'/movements', data)
    commit('serviceFormsMovements', res.data);
    commit('dealerLoading', false);
}

export const servicemovements_add = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("post","technical-service/"+data.id+'/movements', data)
    commit('serviceFormStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const servicemovementsphoto_add = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("put","technical-service/movements/"+data.id+'/image', data.formData)
    commit('serviceFormMovePhotoStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const servicemovementsproduct_add = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("post","technical-service/movements/"+data.id+'/products', data)
    commit('serviceFormStatus', res.data);
    commit('companyStatus', res.data);
    commit('dealerLoading', false);
}

export const serviceFormDetail = async ({commit}, data) => {
    commit('dealerLoading', true);
    let res;
    res = await sendReq("get","technical-service/"+data.id, data)
    commit('serviceFormDetail', res.data);
    commit('dealerLoading', false);
}



// WEBPACK FOOTER //
// ./src/store/modules/Dealer/Actions.js